
import {Component, Vue, Watch} from 'vue-property-decorator';
import stores from '@/stores';
import vPagination from '@/components/VuePlainPagination.vue';
import Skeleton from '@/modules/Skeleton.vue';
import NevronSearch from '@/components/NevronSearch.vue';
import NevronClickConfirm from '@/components/NevronClickConfirm.vue';
import NevronSearchNoResults from '@/components/NevronSearchNoResults.vue';
import CreatePackage from './Create.vue';
import PerPageDropdown from '../../components/PerPageDropdown.vue';
import _ from 'lodash';
import ListNevronHeader from '@/components/ListNevronComponents/ListNevronHeader.vue';
import EmptyNevronHeader from '@/components/ListNevronComponents/EmptyNevronHeader.vue';

@Component({
  components: {
    vPagination,
    ListNevronHeader,
    EmptyNevronHeader,
    Skeleton,
    NevronSearch,
    NevronSearchNoResults,
    NevronClickConfirm,
    CreatePackage,
    PerPageDropdown,
  },
})

export default class PackageList extends Vue {
  response: any = null;
  items = stores.Package;

  firstLoad = true;
  perpage = 20;

  search: any = {
    query: '',
    current: '',
  };

  indexList: number[] = [];
  allChecked: boolean = false;

  searchItems = _.debounce(() => {
    this.fetchData(1, this.search.query, this.perpage);
  }, 400); // fetches data with debounce (ms)
  /*
   * Watch for pagination
   */
  @Watch('response.currentPage')
  ChangedPage() {
    if (this.firstLoad) {
      this.firstLoad = false;
      return;
    }
    this.search.query = this.search.current;
    this.fetchData(this.response.currentPage, this.search.current, this.perpage);
  }

  perPageChange() {
    this.fetchData(1, this.search.query, this.perpage);
  }

  /**
   * Called when changes need to re-render
   */
  mounted() {
    // set search query from URL
    if (this.$route.query.search) {
      this.search.query = this.$route.query.search;
      this.search.current = this.$route.query.search;
    }

    // set page from URL
    let index = 1;
    if (this.$route.query.page) {
      index = Number(this.$route.query.page);
    }
    // set perpage from URL
    if (this.$route.query.perpage) {
      this.perpage = Number(this.$route.query.perpage);
    }
    // load data
    this.fetchData(index, this.search.current, this.perpage);
  }

  openItem(itemId: string | number) {
    this.$router.push({
      name: 'packages.show',
      params: {id: String(itemId)},
      query: {
        lastpage: this.response.currentPage,
        perpage: String(this.perpage),
      },
    });
  }

  /* removes or appends all items ids on current page to indexList */
  checkAll() {
    if (!this.allChecked) {
      this.indexList = Array.from(new Set([...this.indexList, ...this.itemIds]));
      this.allChecked = true;
    } else {
      this.indexList = this.indexList.filter((id) => !this.itemIds.includes(id));
      this.allChecked = false;
    }
  }

  /* when item is checked */
  updateCheck() {
    if (this.itemIds.every((id: number) => this.indexList.includes(id))) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
  }

  get itemIds(): number[] {
    // @ts-ignore
    return this.items.map((item: any) => item.id);
  }

  unknownClicked() {
    return null;
    // return new Promise((resolve, reject) => {
    //   axios.put(`/protected/accounts/search/set`,
    //   {
    //     ids: this.indexList,
    //     operation: 'unknown',
    //   })
    //   .then((response) => {
    //     console.log(response);
    //   }).catch((e) => {
    //     console.log(e);
    //     reject(e);
    //   });
    // });
  }

  refresh() {
    this.fetchData(this.response.currentPage, null, this.perpage);
  }

  /**
   * Fetches data on the specified page and with the specified query
   */
  fetchData(index: number | null, search: string | null, perpage: number | 20) {
    return stores.Package.fetchData(index, search, perpage)
      .then((response) => {
        // wrong page
        if (response.currentPage < 0) {
          this.fetchData(1, search, perpage);
        } else if (response.currentPage > response.lastPage) {
          this.fetchData(response.lastPage, search, perpage);
        } else {
          this.response = response;
          this.items = this.response.data;

          // TODO to je treba rešiti lepše
          // če je page=1 potem tega ne dodamo :)
          if (this.search.query === '') {
            this.$router.push({query: {page: String(this.response.currentPage)}});
          } else {
            this.$router.push({
              query: {
                page: String(this.response.currentPage),
                search: this.search.query,
              },
            });
          }
          this.search.current = this.search.query;
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
}
